import React, { useState, useEffect, Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { Search } from 'semantic-ui-react';
import { useStore } from '../../stores/Store';


interface IProps {
    name: string,
    value: string,
    setData: (name: string, value: string) => void,
    setLocalState: (value: string) => void;
}


const CustomerNameTypeAhead: React.FC<IProps> = ({ name, value, setData, setLocalState }) => {
    const { customerStore } = useStore();
    const { loadingSearch, typeAheadSearchCustomers, searchedCustomers } = customerStore;

    const [searchTerm, setSearchTerm] = useState(value);
    const [handler, setHandler] = useState<any>(null);

    useEffect(() => {
        if (value === '')
            setSearchTerm('');
        if (value !== searchTerm)
            setSearchTerm(value);

    }, [value, searchTerm])

    const handleResultSelect = (e: any, { result }: any) => {
        setSearchTerm(result.fullname);
        setLocalState(result.fullname);


        //setData('so_customer_id', result.yellowpages_id);
        //setData('so_customer_alias', result.name_alias);
        setData('so_customer_name', result.fullname);
        /*
        if (result.billing_address !== "") {
            setData('so_billing_address', result.billing_address);
            setData('so_sold_address', result.billing_address);
        } else {
            setData('so_billing_address', result.address);
            setData('so_sold_address', result.billing_address);
        }

        if (result.shipping_address !== "") {
            setData('so_shipping_address', result.shipping_address);
        } else {
            setData('so_shipping_address', '');
        }
        */

        //setData(name, searchTerm);
    }


    const handleSearchChange = (e: any, { value }: any) => {
        if (searchTerm === value) return;
        setLocalState(value);
        setSearchTerm(value);
        //setData(name, value);
        if (value === '') return;

        if (handler) {
            clearTimeout(handler);
        }
        let newHandler = setTimeout(() => {
            typeAheadSearchCustomers('name', value);
        }, 500);
        setHandler(newHandler);
    }

    const handleOnBlur = () => {
        setData(name, searchTerm);
    }
    const handleOnFocus = () => {
        setSearchTerm('');
        setLocalState('');
        //resetSearchedCustomers();
    }

    return (
        <Fragment>
            <Search style={{ marginTop: 0, marginBottom: 22 }}
                fluid
                loading={loadingSearch}
                aligned='right'
                placeholder='Customer Name'
                onFocus={handleOnFocus}
                onResultSelect={handleResultSelect}
                onSearchChange={handleSearchChange}
                results={searchedCustomers ? searchedCustomers : []}
                value={searchTerm}
                name={name}
                onBlur={handleOnBlur}
                resultRenderer={(result) =>
                (
                    result && result.fullname &&
                    <div key={result.fullname} className='content'>
                        {result.fullname && <div>{result.fullname}</div>}
                    </div>
                )}
            />
        </Fragment>
    )
}

export default observer(CustomerNameTypeAhead)
